/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Whether the slot holds a single booking, many (a group slot), or is an open range ('RANGE') where clients book a fixed-duration sub-window. RANGE slots serve one client at a time, are priced per duration (priceByDuration), and `price` is the cheapest of those (the public 'from' amount).
 */
export enum SlotType {
  SINGLE = 'SINGLE',
  GROUP = 'GROUP',
  RANGE = 'RANGE'
}
